import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { getSectors, type GetSectorsParams } from "@/api/endpoints/sectors";
import { queryKeys } from "@/lib/queryClient";
import type { UseQueryOptions } from "@tanstack/react-query";
import type { Sector } from "@/types/risk-analysis";

export function useGetSectors(
  params?: GetSectorsParams,
  config?: UseQueryOptions
): UseQueryResult<Sector[], Error> {
  return useQuery({
    queryKey: queryKeys.sectors.list(params?.context),
    queryFn: () => getSectors(params),
    ...config,
  }) as UseQueryResult<Sector[]>;
}
